<template>
  <panel :title="title">
    <div slot="header-right">
      <button :disabled="addingImage" v-bind:class="{ 'is-loading': addingImage }" @click="addingImage = true" slot="header-actions" class="hint hint--left btn btn--info" data-label="Adicionar uma imagem em uma ou mais variações">
        Adicionar Imagem
      </button>

      <modal-add-image :visible="addingImage" :variations="product.variations" :callback="uploadedImage" v-on:close="close => addingImage = close" :module="moduleUploadImageModal"/>
    </div>

    <div v-if="category.variations_combinations.length && !typeCheckout">
      <variation-type-multi :productId="product.productId" v-for="variation in product.variations" :key="variation" :variation="variation" :category="category" :fromModule="fromModule" :product="product" />
    </div>

    <variation-type-single :product="product" :typeCheckout="typeCheckout" :category="category" v-if="!category.variations_combinations.length || typeCheckout" :fromModule="fromModule" v-on:changeTypeCheckout="changeTypeCheckout"/>
  </panel>
</template>

<script>
import Panel from '@/components/template/Panel'
import FormGroup from '@/components/template/FormGroup'
import VariationTypeSingle from '@/components/marketplace/mercadoLivre/announcement/variation/Single'
import VariationTypeMulti from '@/components/marketplace/mercadoLivre/announcement/variation/Multi'
import ModalAddImage from '@/components/marketplace/shared/provide/ModalAddImage'

export default {
  data: () => ({
    addingImage: false
  }),
  props: {
    product: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    fromModule: {
      type: Object,
      required: true
    },
    typeCheckout: {
      type: Boolean,
      required: true
    }
  },
  created () {
    this.product.variationsCombination = null
  },
  methods: {
    uploadedImage (urls, variations) {
      for (let i in variations) {
        const sku = variations[i].sku
        const variation = this.product.variations.find(variation => variation.sku === sku)

        if (variation === undefined) {
          continue
        }

        for (let j in urls) {
          variation.images.push(urls[j])
        }
      }

      variations.splice(0, variations.length)
    },
    changeTypeCheckout (v) {
      this.$emit('changeTypeCheckout', v)
    }
  },
  computed: {
    title () {
      return this.category.variations_combinations.length ? 'Variações' : 'Variação'
    },
    moduleUploadImageModal () {
      return {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      }
    }
  },
  components: {
    Panel,
    VariationTypeSingle,
    VariationTypeMulti,
    FormGroup,
    ModalAddImage
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Variation.vue?2de3958d